import moment from "moment-timezone";
import Text from "common/Typography/Text.tsx";
import Select from "common/Select/Select.tsx";
import { useMemo } from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface TimezoneSelectorProps {
  timezone: string;
  setTimezone: (timezone: string) => void;
  defaultTimezone: string;
}

const TimezoneSelector = ({
  timezone,
  setTimezone,
  defaultTimezone,
}: TimezoneSelectorProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const options = useMemo(() => {
    const timezoneData = moment.tz.names().map((timezone) => {
      const offset = moment.tz(timezone).format("Z");
      return {
        name: timezone,
        offset,
        label: `(GMT${offset}) ${timezone}`,
        value: timezone,
      };
    });

    return timezoneData
      .sort((a, b) => {
        if (a.offset !== b.offset) {
          return a.offset.localeCompare(b.offset);
        }
        return a.name.localeCompare(b.name);
      })
      .map(({ label, value }) => ({ label, value }));
  }, []);

  const onChange = (value: string) => {
    setTimezone(value ?? defaultTimezone);
  };

  return (
    <>
      <Text style={{ marginBottom: 8 }}>Timezone</Text>
      <Select
        value={timezone}
        options={options}
        onChange={onChange}
        style={{ width: "100%" }}
        mobileTitle={t("operation_hours.timezone")}
      />
    </>
  );
};

export default TimezoneSelector;
